import { useCallback } from 'react';
import { generatePath, useHistory } from 'react-router-dom';

import useHelpModal from 'components/HelpModal/useHelpModal';
import { URLS } from 'config';

import { useCurrentJob } from '../../hooks';
import { formatLogo } from '../../utils';

const ContainerComponent = ({ children }) => {
  const { job, isLoading } = useCurrentJob();
  const { push } = useHistory();
  const { showHelpModal } = useHelpModal();

  const logo = formatLogo(job?.company?.company_logo);

  const onClick = useCallback(() => {
    const id = job?.id;
    if (!id) return;
    push(generatePath(URLS.job, { id }));
  }, [job, push]);

  return children({
    ...logo,
    isLoading,
    onClick,
    showHelpModal,
  });
};

ContainerComponent.displayName = 'MobileHeader-container';

export default ContainerComponent;
